import styled, { css } from "styled-components";

const NotificationBoxStyled = styled.div`
    padding: 6rem 3.2rem 3.2rem;
	border: 1px solid ${props => props.borderColor};
	border-radius: 0.5rem;
    margin-bottom: 3.4rem;
	position: relative;

    @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
        margin-bottom: 4rem;
		padding: 3.2rem;
    }

	.closeBn {
		position: absolute;
		right: 2.4rem;
		top: 2.4rem;
	}

	.boxContent {
		display: flex;
		justify-content: space-between;
		flex-direction: column;

		@media only screen and (min-width: ${props => props.theme.desktopSmall}) {
			flex-direction: row;
			align-items: center;

			button {
				margin-left: 2rem;
			}

			p {
				margin: 0;
			}
		}
	}
`;

export default NotificationBoxStyled;
